import { ref } from 'vue'

import {
  SharedDataType,
  GetTokenOptions,
} from '@sennder/senn-node-microfrontend-interfaces'
import { cloneReactiveToRaw } from '@sennder/shell-utilities'

import { logger } from '@/services/logger/loggers'
import { getStateData } from '@/store'
import { getFunction, MFRepositories } from '@sennder/microfrontend-registry'
import type { RemoteFunctionTypes } from '@sennder/microfrontend-registry/OttersAuth'

export const auth = ref<RemoteFunctionTypes>()

export const loadAuthRemoteFunction = async () => {
  if (!auth.value) {
    const { default: RemoteFunction } = await getFunction(
      MFRepositories.OttersAuth,
      'RemoteFunctions',
      { integrator: 'otters-shell' }
    )

    // TODO: We need to change the way how aut MF is integrated with the shell (pass the provider?)
    const featureFlags = getStateData().featureFlags
    auth.value = new RemoteFunction(SharedDataType.OTTERS, {
      logger,
      featureFlags: cloneReactiveToRaw(featureFlags),
    })
  }

  await auth.value.initializeAuthInstance()
}

export async function getAuthHeader(options?: GetTokenOptions) {
  if (!auth.value) {
    throw new Error('[otters-shell - getAuthHeader]: Auth module is not loaded')
  }
  const token = await auth.value.getAuthToken(options)
  return token ? `Bearer ${token}` : null
}
